export const getNameFromDocument = (document: string) => {
  const lastSlashIndex = document.lastIndexOf("/");
  return document.substring(lastSlashIndex + 1);
};
